import { renderCheckboxComponent } from '@ticketmaster/tm1pos-web-shared/components/Checkbox';
import { renderDropdownComponent } from '@ticketmaster/tm1pos-web-shared/components/Dropdown';
import { PRINT } from '@ticketmaster/tm1pos-web-shared/constants';
import EditPrinterModal from '@ticketmaster/tm1pos-web-shared/printing/Configuration/Modal';
import { initializePrintingModule } from '@ticketmaster/tm1pos-web-shared/printing/printingModule-slice';
import classnames from 'classnames';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Field } from 'redux-form/immutable';
import './print-receipt.scss';
import { normalizeFn } from '../../utils';
import PrintControl from '../print-control/print-control-connected';

export const printerQuantityProvider = [
  {
    label: '0',
    value: '0',
  },
  {
    label: '1',
    value: '1',
  },
  {
    label: '2',
    value: '2',
  },
];

type PrintReceiptProps = {
  active: boolean;
  quantity: {
    label: string;
    value: string;
  };
  deliveryMethod: string;
  label: string; // `label` might also be an object according to legacy PropTypes, but punting on that for now
};

export const PrintReceipt = ({ active, quantity, deliveryMethod, label }: PrintReceiptProps) => {
  const [showEdit, setShowEdit] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initializePrintingModule());
  }, [dispatch]);

  const classes = classnames({
    'sdr-checkout__print-receipt': true,
    'sdr-checkout__print-receipt--active': active,
  });
  const showPrinterField = deliveryMethod === PRINT || (active && parseInt(quantity.value, 10) > 0);
  const receiptControl = (
    <div className={classes} key="receipt-control">
      <Field
        className="oc-toggle-switch--small"
        checked={active}
        component={renderCheckboxComponent}
        id="printReceiptToggle"
        name="printReceiptToggle"
        normalize={normalizeFn}
        text={label}
      />
      {active ? (
        <Field
          component={renderDropdownComponent}
          name="printReceiptCount"
          selection={quantity || printerQuantityProvider[1]}
          dataProvider={printerQuantityProvider}
          emptySelection={printerQuantityProvider[1].label}
        />
      ) : null}
    </div>
  );

  const editModal = showEdit ? <EditPrinterModal onClose={() => setShowEdit(false)} /> : null;

  let printerControl;
  if (showPrinterField) {
    printerControl = <PrintControl />;
  } else {
    printerControl = null;
  }

  return (
    <>
      {receiptControl}
      {printerControl}
      {editModal}
    </>
  );
};
